import { ValidatorFn } from '@angular/forms';
import { MenuRadioItemInterface } from '@shared/ui/menu';
import { Observable } from 'rxjs';
import { ValidationConfig } from './error/form-error.interface';

export interface FormDataInterface {
  title: string;
  form?: FormConfigInterface;
  actions?: FormActionInterface[];
  autoHeightDisabled?: boolean;
}

export interface FormConfigInterface {
  ids: string[];
  controls: Record<string, FormControlInterface>;
  validators?: ValidatorFn[];
}

export interface FormControlInterface {
  type: FormControlTypeEnum;
  title?: string;
  value?: string | number | boolean;
  options?: MenuRadioItemInterface[];
  placeholder?: string;
  validation?: ValidationConfig;
  view?: any;
  testId?: string;
}

export interface FormActionInterface {
  title?: string;
  focus?: boolean;
  type?: FormButtonTypeEnum;
  disableClose?: boolean;
  testId?: string;
  action?: (
    value?: any,
    controls?: Record<string, FormControlInterface>,
    event?: Event | MouseEvent,
  ) => Observable<any>;
}

export enum FormButtonTypeEnum {
  PRIMARY,
  SECONDARY,
}

export enum FormControlTypeEnum {
  INPUT = 1,
  INPUT_PASSWORD,
  INPUT_COPY,
  CHECKBOX,
  SELECT,
  LABEL,
  INFO,
  INFO_WARNING,
  COMPONENT,
}

export const activeFormControls = [
  FormControlTypeEnum.INPUT,
  FormControlTypeEnum.INPUT_PASSWORD,
  FormControlTypeEnum.INPUT_COPY,
  FormControlTypeEnum.CHECKBOX,
  FormControlTypeEnum.SELECT,
];
